<template >
  <!-- eg.    <template slot-scope="{item}">
          {{item.name}}padding-top:3px;
          <el-tag type="info">{{item.loc_name}}</el-tag>
  </template>-->
  <div
      v-loading="!ready"
      style="width:100%;" >
    <!--    <p >=...={{ selectedOption }}</p >-->

    <!-- -->
    <div
        v-if="safeMode"
        class="r-select" >
      <q-select
          v-if="!multiple"
          :dark="dark"
          :dense="true"
          filled
          autofocus
          behavior="menu"
          :stack-label="true"
          tabindex="-1"
          v-model="selectedOption"
          clearable
          hide-bottom-space
          use-input
          :prefix="selectedOption&&selectedOption[captionField]?selectedOption[captionField]:null"
          :suffix="selectedOption&&selectedOption[prefixField]?selectedOption[prefixField]:null"
          :option-value="valueProp"
          :option-label="labelProp"
          fill-input
          :new-value-mode="simpleNewValue?'add':null"
          hide-selected
          input-debounce="0"
          :options="loadedOptions"
          @filter="remoteSearch"
          :placeholder="placeholder"
          @new-value="createValue"
          @blur="createValue()"
          @input="inferHide=false"
          :style="(fullWidth?'width: 100%':'')" >
        <template v-slot:no-option >
          <q-item >
            <q-item-section class="text-grey" >No results</q-item-section >
          </q-item >
        </template >

        <template v-slot:option="scope" >
          <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents" >
            <q-item-section class="pl-2" >
              <q-item-label >
                <span v-html="optionRender?optionRender(scope.opt):scope.opt[labelProp]" ></span >
                <span
                    class="option-prefix"
                    v-if="prefixField&&scope.opt[prefixField]" >{{ scope.opt[prefixField] }}</span >
              </q-item-label >
              <q-item-label
                  v-if="captionField&&scope.opt[captionField]"
                  caption >

                {{ scope.opt[captionField] }}
              </q-item-label >
            </q-item-section >
          </q-item >
        </template >
      </q-select >
      <q-select
          v-else
          :option-value="valueProp"
          :option-label="labelProp"
          filled
          autofocus
          behavior="menu"
          use-input
          use-chips
          :placeholder="placeholder"
          multiple
          tabindex="-1"
          input-debounce="0"
          v-model="selectedOption"
          :options="loadedOptions"
          @filter="remoteSearch"
          :dark="dark"
          :dense="true"
          :stack-label="false"
          emit-value
          map-options >
        <template v-slot:option="scope" >
          <q-item
              v-bind="scope.itemProps"
              v-on="scope.itemEvents" >
            <q-item-section class="pl-2" >
              <q-item-label >
                <span v-html="optionRender?optionRender(scope.opt):scope.opt[labelProp]" ></span >
                <span
                    class="option-prefix"
                    v-if="prefixField&&scope.opt[prefixField]" >{{ scope.opt[prefixField] }}</span >
              </q-item-label >
              <q-item-label
                  v-if="captionField&&scope.opt[captionField]"
                  caption >

                {{ scope.opt[captionField] }}
              </q-item-label >
            </q-item-section >
          </q-item >
        </template >
      </q-select >

    </div >
    <q-select
        v-else
        :dark="dark"
        :dense="true"
        filled
        tabindex="-1"
        autofocus
        behavior="menu"
        :stack-label="true"
        v-model="selectedOption"
        clearable
        hide-bottom-space
        use-input
        :suffix="selectedOption&&selectedOption[prefixField]?selectedOption[prefixField]:null"
        :option-value="valueProp"
        xoption-label="labelProp"
        :display-value="selectedOption?selectedOption[labelProp]:''"
        xfill-input
        :new-value-mode="simpleNewValue?'add':null"
        xhide-selected
        :display-value-sanitize="false"
        input-debounce="0"
        :options="loadedOptions"
        @filter="remoteSearch"
        :placeholder="placeholder"
        @new-value="createValue"
        @blur="createValue()"
        @input="inferHide=false"
        :style="fullWidth?'width: 100%':''" >
      <template v-slot:no-option >
        <q-item >
          <q-item-section class="text-grey" >No results</q-item-section >
        </q-item >
      </template >

      <template v-slot:option="scope" >
        <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents" >
          <q-item-section class="pl-2" >
            <q-item-label v-html="scope.opt[labelProp]" >

            </q-item-label >

            <q-item-label
                v-if="captionField&&scope.opt[captionField]"
                caption >
 <span
     class="option-prefix"
     v-if="prefixField&&scope.opt[prefixField]" >{{ scope.opt[prefixField] }}</span >
              {{ scope.opt[captionField] }}
            </q-item-label >
          </q-item-section >
        </q-item >
      </template >
    </q-select >
    <template v-if="editOptionComponentIs" >??
<!--      <el-button-->
<!--          @click="editOption()"-->
<!--          type="text"-->
<!--          style="flex:1" >-->
<!--        <fa-->
<!--            v-if="cvalue"-->
<!--            icon="pen"-->
<!--            fixed-width-->
<!--            size="lg" ></fa >-->
<!--        <fa-->
<!--            v-else-->
<!--            icon="plus"-->
<!--            fixed-width-->
<!--            size="lg" ></fa >-->
<!--      </el-button >-->
<!--      <el-dialog-->
<!--          append-to-body-->
<!--          :title="modalTitle"-->
<!--          :visible.sync="editorDialogVisible"-->
<!--          width="30%"-->
<!--          xbefore-close="handleEditorClose" >-->
<!--        <component-->
<!--            v-if="editOptionComponentIs"-->
<!--            :is="editOptionComponentIs"-->
<!--            v-bind="editOptionComponentProps"-->
<!--            v-model="selectedOption"-->
<!--            @change="updateOption"-->
<!--            @delete="updateOption"-->
<!--            @cancel="editorDialogVisible=false" ></component >-->
<!--      </el-dialog >-->
    </template >
  </div >
</template >

<script >
// import mdl from "~/mixins/mdl";
import {mapActions, mapGetters} from "vuex";
import * as api from "~/api/resource";
import _ from "lodash";
import {getModxList} from "../../api/resource";

let cachedIncomingValue = null

export default {
  name: "QRemoteSelect",
  data() {
    return {
      hidePrefix: false,
      cvalue: null,
      lastSearch: null,
      cachedRemoteQ: null,
      ready: false,
      inferHide: false,
      newVal: null,
      loading: false,
      loadedOptions: this.options,
      selectedOption: null,
      content: null,
      editorDialogVisible: false,
    };
  },
  props: {
    optionRender: {type: Function, default: null},
    safeMode: {type: Boolean, default: true},
    fullWidth: {type: Boolean, default: true},
    dark: {type: Boolean, default: false},
    optionsPostParser: {type: Function, default: null},
    sortField: {type: String, default: null},
    prefixField: {type: String, default: null},
    captionField: {type: String, default: null},
    disabled: {type: Boolean, default: false},
    autoSelectOne: {type: Boolean, default: false},
    optionsRepo: {type: String, default: null},
    large: {type: Boolean, default: false},
    viewMode: {type: Boolean, default: false},
    cellMode: {type: Boolean, default: false},
    limit: {type: Number, default: 60},
    editOptionComponentIs: {type: String, default: null},
    editOptionComponentProps: {type: Object, default: () => null},
    focusthis: {default: false},
    filterable: {default: true},
    clearable: {default: true},
    multiple: {default: false},
    newOptionProps: {type: Object, default: () => null},
    remoteValueSelector: {type: Object, default: () => null},
    allowCreate: {type: Boolean, default: false},
    simpleNewValue: {type: Boolean, default: false},
    // ref: { default: null },
    options: {default: null},
    value: {default: null},
    queryProp: {type: String, default: "search"},
    extraQueryParams: {
      type: Object, default: () => {
      }
    },
    classModel: {type: String, default: null},
    fetchProcessor: {type: String, default: null},
    placeholder: {type: String, default: null},
    labelProp: {type: String, default: "name"},
    valueProp: {type: String, default: "id"},
  },
  watch: {
    extraQueryParams: {
      handler: function (newValue) {
        const qStamp = JSON.stringify(newValue);
        if (qStamp != this.cachedRemoteQ) {
          this.cachedRemoteQ = qStamp;
          this.remoteSearch();
        }
      },
      deep: true,
    },
    value: {
      // immediate: true,
      deep: true,
      async handler(v, vo) {
        _log_("value handler.1.", v, vo);
        if (v === vo)
          return
        let similarityCheck = 0
        if (_.isArray(v) && _.isArray(vo)) if (v.length == vo.length) {
          for (let i = 0; i < v.length; i++)
            if ((v[i] + "") === (vo[i] + "")) ++similarityCheck
          _log_("value handler.2.", v.length, similarityCheck);
          if (similarityCheck == v.length) return
        }

        //
        await this.displayOption(v);
        // this.selectedOption = null
        _log_("value handler.3....", v);
        if (_.isArray(v)) {
          if (!v.length) return
        }
        else if (!v)
          return
        _log_("value handler.4.godisplayOption...", v);


        this.$emit("change-option-data", this.selectedOption);
        this.hidePrefix = false;

      }
    },
    // async valuehandler(v, vo) {
    //   // _log_("step-remote....selectg...", this.cvalue, v, vo);
    //   if (v != vo && v + "" != this.cvalue + "") {
    //     // _log_("selectedOption..godisplayOption...", v);
    //     await this.displayOption(v);
    //     this.$emit("change-option-data", this.selectedOption);
    //     this.hidePrefix = false;
    //   }
    // },
    selectedOption: {
      handler: function (optval) {
        // _log_("selectedOption.handler..h.", this.loadedOptions, optval);
        let oldval = this.cvalue;
        let val = optval
        if (!this.multiple)
          val = optval ? optval[this.valueProp] : null;
        if (!oldval && val + "" == this.value + "") {
          if (this.selectedOption)
            this.$emit("change-option-data", this.selectedOption);
          return;
        }
        if (val != oldval) {
          var qo = {};
          qo[this.valueProp] = val;
          // if (this.newVal[this.valueProp] == qo[this.valueProp])
          //   this.selectedOption = this.newVal;
          // else
          if (!this.multiple)
            this.selectedOption = this.findInArray(this.loadedOptions, qo);
          this.hidePrefix = false;

          if (this.cvalue != val) {
            this.$emit("input", val);
            // _log_('emit....change', {
            //   val: val,
            //   oldval: oldval,
            //   obj: this.selectedOption,
            // })
            this.$emit("change", {
              val: val,
              oldval: oldval,
              obj: this.selectedOption,
            });
            this.$emit("change-option-data", this.selectedOption);
          }

        }
        this.cvalue = val;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    modalTitle() {
      var t = "Edit:";
      t +=
          this.selectedOption && this.selectedOption[this.valueProp]
              ? this.selectedOption[this.valueProp]
              : "option";
      return t;
    },
    ...mapGetters({
      getList: "tags/getList",
    }),

    selectedOptions() {
      // _log_("find selectedOptions." + this.cvalue, this.optionsRepo);
      if (!this.cvalue || this.cvalue == "" || this.cvalue == 0)
        return "&nbsp;";
      if (this.valueProp == "raw") return this.cvalue;
      var avOptions = null;
      if (this.optionsRepo) {
        avOptions = this.getList(this.optionsRepo);
      }
      // THEDC.repoDB[this.optionsRepo];
      else avOptions = this.options;
      // _log_("find sel."+this.optionsRepo, avOptions,q);
      var q = {};
      q[this.valueProp] = this.cvalue + "";
      var o = _.find(avOptions, q);
      if (o) return o[this.labelProp];
      else {
        q[this.valueProp] = this.cvalue;
        o = _.find(avOptions, q);
        if (o) return o[this.labelProp];
      }
      return "?" + this.cvalue;
    },
  },
  // async created() {
  //   _log_("change sel.", this.optionsRepo);
  //   if (this.optionsRepo) {
  //     this.loadedOptions = await this.fetch(this.optionsRepo);
  //   }
  //   // // await this.remoteSearch();
  //   // if (this.value) this.cvalue = this.value + "";
  //   // _log_("CREATE sel.", this.cvalue);
  // },
  methods: {
    labelFn(item) {
      if (!item) return null;
      return (
          "<span class='option-prefix'>" +
          item[this.prefixField] +
          "</span>" +
          item[this.valueProp]
      );
    },
    createValue(val, done) {
      if (!this.simpleNewValue || this.selectedOption) return;
      val = val ? val : this.lastSearch;
      if (!val) return;
      _log_("CREATE sel..selectedOption.", val);
      this.newVal = {};
      this.newVal[this.valueProp] = val;
      this.newVal[this.labelProp] = val;
      this.loadedOptions.push(this.newVal);
      // specific logic to eventually call done(...) -- or not
      if (done) done(this.newVal, "toggle");
      else {
        this.updateOption(this.newVal);
        this.selectedOption = this.newVal;

        this.$emit("input", val);
        this.$emit("change", {val: val, oldval: null});
        this.$emit("change-option-data", this.selectedOption);
      }
      this.newVal = null;
      // this.selectedOption = newVal;
      this.inferHide = false;

      // done callback has two optional parameters:
      //  - the value to be added
      //  - the behavior (same values of new-value-mode prop,
      //    and when it is specified it overrides that prop –
      //    if it is used); default behavior (if not using
      //    new-value-mode) is to add the value even if it would
      //    be a duplicate
    },
    async updateOption(v) {

      if (!v || (this.multiple && !v.length)) {
        //removed
        this.cvalue = null;
        this.selectedOption = null;
        this.editorDialogVisible = false;
        return;
      }
      let _v = _.isArray(v) ? v : [v]
      _log_("updateOption start.", v, _v, _v.length);
      for (let v_i = 0; v_i < _v.length; v_i++) {
        _log_("updateOption start..for.", v_i, _v, _v.length);
        let v_option = _v[v_i]
        let qo = {};
        qo[this.valueProp] = _.isObject(v_option) ? v_option[this.valueProp] : v_option;
        v_option = this.findInArray(this.loadedOptions, qo)
        if (!v_option) {
          if (!this.newVal)
            if (this.classModel) v_option = await api.fetchObject(this.classModel, qo);
          if (!this.loadedOptions || !this.loadedOptions.length) {
            this.loadedOptions = [v_option];
          }
          else {
            this.loadedOptions.push(v_option);

            // _log_("updateOption check.", qo, this.loadedOptions);
            // if (!this.findInArray(this.loadedOptions, qo)) {
            //   if (!this.newVal || v_option[this.valueProp] != this.newVal[this.valueProp])
            //     if (this.classModel) v_option = await api.fetchObject(this.classModel, qo);
            //   _log_("updateOption add.", v_option, this.loadedOptions);
            //   this.loadedOptions.push(v_option);
            //
            // }
            // else {
            //
            //   this.updateArray(this.loadedOptions, qo, v_option);
            //   _log_("updateOption updated.", v_option, this.loadedOptions);
            // }
          }

          if (this.multiple) {
            if (!this.cvalue) this.cvalue = [v_option]
            else if (!this.findInArray(this.cvalue, qo)) this.cvalue.push(v_option)
            if (!this.selectedOption) this.selectedOption = [v_option]
            else if (!this.findInArray(this.selectedOption, qo)) this.selectedOption.push(v_option)
          }
          else {
            this.cvalue = v_option[this.valueProp];
          }
        }
      }
      this.stringifyProp(this.loadedOptions, this.valueProp);
      this.editorDialogVisible = false;
    }
    ,
    editOption() {
      this.selectedOption = this.cvalue
          ? this.selectedOption
          : this.newOptionProps;
      this.editorDialogVisible = true;
    }
    ,
    handleEditorClose() {
    }
    ,
    createOption() {
      this.editOptionRoute();
      this.editorDialogVisible = true;
    }
    ,
    // async  filterFn (val, update, abort){},
    async remoteSearch(val, update, abort) {
      const vm = this;
      _log_("is ins..F.", val, this.newVal);
      // this.loading = true;
      if (!val)
        if (this.newVal && (this.newVal[this.valueProp] == val || !val)) {
          // this.newVal = null;
          return;
        }
      if (val) this.inferHide = true;
      this.lastSearch = val;
      let loadedOptions = null;
      if (this.options) {
        loadedOptions = JSON.parse(JSON.stringify(this.options))
        // _log_("is loadedOptions..F.", loadedOptions, this.loadedOptions);
        if (val)
          loadedOptions = loadedOptions.filter(e => (e[vm.labelProp] && e[vm.labelProp].toLowerCase()
                                                                                       .indexOf(val.toLowerCase()) >= 0) || (vm.captionField && e[vm.captionField] && e[vm.captionField].toLowerCase()
                                                                                                                                                                                        .indexOf(val.toLowerCase()) >= 0)
              || (vm.prefixField && e[vm.prefixField] && e[vm.prefixField].toLowerCase()
                                                                          .indexOf(val.toLowerCase()) >= 0))
        update(() => {
          this.loadedOptions = loadedOptions;
          this.stringifyProp(loadedOptions, this.valueProp);
          // _log_("is update.loadedOptions.F.", this.loadedOptions);
        });
        return

      }
      else if (this.optionsRepo) {
        loadedOptions = this.getList(this.optionsRepo)
        // _log_("is loadedOptions..F.", loadedOptions, this.loadedOptions);
        if (val)
          loadedOptions = loadedOptions.filter(e => e[vm.labelProp] && e[vm.labelProp].toLowerCase()
                                                                                      .indexOf(val.toLowerCase()) >= 0)
        update(() => {
          this.loadedOptions = loadedOptions;
          this.stringifyProp(loadedOptions, this.valueProp);
          // _log_("is update.loadedOptions.F.", this.loadedOptions);
        });
        return

      }
      let q = val,
          goQ = {...this.extraQueryParams};
      goQ[this.queryProp] = q ? q : "";
      goQ.limit = this.limit

      loadedOptions = this.classModel
          ? await api.getModxList(this.classModel, goQ)
          : await api.getModxProcessor(this.fetchProcessor, goQ, true);
      // loadedOptions = loadedOptions.results
      //   ? loadedOptions.results
      //   : loadedOptions;
      if (this.sortField)
        loadedOptions = loadedOptions.sort((a, b) => a[vm.sortField] - b[vm.sortField]);
      _log_("is ins..SEARCH.loadedOptions.", loadedOptions);
      if (q) this.hidePrefix = true;
      loadedOptions = loadedOptions ? loadedOptions : [];
      if (this.selectedOption) this.updateOption(this.selectedOption);
      // if (this.newVal) this.loadedOptions.push(this.newVal);
      if (this.optionsPostParser) {
        const PP = this.optionsPostParser;
        loadedOptions = loadedOptions.map(function (item) {
          return PP(item);
        });
      }

      // _log_("is ins..F.", goQ, this.loadedOptions);

      if (!update) {
        this.stringifyProp(loadedOptions, this.valueProp);
        if (
            this.autoSelectOne &&
            this.loadedOptions.length == 1 &&
            !this.cvalue
        ) {
          this.cvalue = this.loadedOptions[0][this.valueProp];
        }
      }
      else
        update(() => {
          this.loadedOptions = loadedOptions;
          this.stringifyProp(loadedOptions, this.valueProp);
          // _log_("is ins..F.", goQ, this.loadedOptions);
        });
      // this.loading = false;
    }
    ,
    async displayOption(v) {
      // _log_("go for opts?displayOption..", this.loadedOptions, v);
      this.loading = true;
      let o = null;
      this.loadedOptions = this.loadedOptions ? this.loadedOptions : [];
      v = v ? v : this.value;
      // _log_("step-remote 1", this.cvalue, v);
      if (this.multiple && v) {
        if (_.isString(v))
          v = v.split(",");
        // else this.selectedOption = v
        let q = {}
        q[this.valueProp] = v
        if (!this.options) {
          const options = await api.getModxList(this.classModel || this.fetchProcessor, {...q, limit: this.limit})
          this.loadedOptions = this.loadedOptions ? [...this.loadedOptions,
                                                     ...options] : options
        }
        this.selectedOption = v.map(el => el + "")
        // this.selectedOption = this.selectedOption ? [...this.selectedOption,
        //                                              ...options] : options
        // _log_("go for opts?displayOption.multiple.", this.loadedOptions, v);
        this.stringifyProp(this.loadedOptions, this.valueProp);
        // this.stringifyProp(this.selectedOption, this.valueProp);
        return;
      }
      else if (!v) {
        // _log_("go for opts?displayOption.null.", v);
        this.selectedOption = null
        //lets try to get it with alternative query
        if (this.remoteValueSelector && this.classModel) {
          // _log_("step-remote 1.2", this.cvalue, v);
          o = await api.fetchObject(this.classModel, this.remoteValueSelector);
          if (o) {
            if (this.optionsPostParser) o = this.optionsPostParser(o);
            this.selectedOption = o;
            this.$emit("init-option-data", this.selectedOption);
            this.loadedOptions.push(o);
            // _log_(
            //   "go for op1111ts",
            //   this.loadedOptions,
            //   this.selectedOption,
            //   o
            // );
            this.stringifyProp(this.loadedOptions, this.valueProp);
          }
        }
        // else this.selectedOption=null
        // _log_("step-remote 1.6", this.cvalue, v);
        this.$nextTick(() => {
          this.cvalue = v ? "" + v : null;
        });

        this.loading = false;
        return;
      }
      if (v === 0) v = null;

      let qo = {};
      qo[this.valueProp] = v;
      // _log_("step-remote 2", this.cvalue, v);
      let oO = this.findInArray(this.loadedOptions, qo);
      if (!oO) {
        // _log_("step-remote 3", this.cvalue, v);
        if (this.labelProp == this.valueProp) {
          oO = {};
          oO[this.labelProp] = v;
        }
        else if (this.classModel)
          oO = await api.fetchObject(this.classModel, qo);
        // _log_("step-remote 4", this.cvalue, v);
        if (!oO) {
          // this.$notify.error({
          //   title: "Something is miising",
          //   message: "there is a missing option",
          // });
          return;
        }
        if (!this.selectedOption) this.$emit("init-option-data", oO);
        oO[this.valueProp] = oO[this.valueProp] + "";
        this.loadedOptions.push(oO);

        // // // _log_("go for opts?3333GOOO..", this.loadedOptions, o);
        // // qo[this.valueProp] = o[this.valueProp];
        // // if (!this.findInArray(this.loadedOptions, qo))
        // //   //second check cause to async issues
        // //   this.loadedOptions.push(o);
        // this.stringifyProp(this.loadedOptions, this.valueProp);
        // _log_("go for opts?3333GOOO..", this.loadedOptions, oO);
      }
      this.$nextTick(() => {
        this.selectedOption = this.multiple ? [oO] : oO;
        this.cvalue = v ? oO[this.valueProp] : null;
      });
      this.loading = false;
    }
    ,
    ...
        mapActions({
          fetch: "tags/fetch",
          fetchAllOptions: "tags/fetchAll",
        }),
    refocus() {
      var vm = this;

      let elel = this.$el; // vm.$refs['sselector']
      // if (elel) elel[0].focus()
      // _log_("change sel.", elel);
      //  elel.focus();
      let inputs = elel.getElementsByTagName("input");
      // let elel = vm.$refs['col_input' + rowScope.column.property]
      // // if (elel) elel[0].focus()
      // _log_('is ins..F.' + colIndex, elel[0])
      inputs[0].focus();
    }
    ,
  },
  async mounted() {
    const vm = this;
    if (this.options)
      this.loadedOptions = this.options
    else if (this.optionsRepo) {
      this.loadedOptions = await this.fetch(this.optionsRepo);
      // _log_('is ins..this.loadedOptions.',this.loadedOptions)
    }
    try {
      await this.displayOption();
    }
    catch (error) {
      console.error(error);
      // this.$notify.error({
      //   title: "Something is miising",
      //   message: "there is a missing option??",
      // });
    }

    // await this.displayOption();
    // if (!this.getList(this.optionsRepo))
    //   await this.fetchAllOptions([this.optionsRepo]);
    // _log_("find sel..SO.", this.getList(this.optionsRepo));
    if (this.focusthis) {
      this.$nextTick(() => {
        let elel = vm.$refs["sselector"];
        // if (elel) elel[0].focus()
        // _log_("is insCCC..F.", elel);
        elel.focus();
        let inputs = elel.$el.getElementsByTagName("input");
        // let elel = vm.$refs['col_input' + rowScope.column.property]
        // // if (elel) elel[0].focus()
        // _log_('is ins..F.' + colIndex, elel[0])
        inputs[0].focus();
      });
    }
    // _log_("is ins.MOUN.F." + this.cvalue);
    // if (!this.cvalue) await this.remoteSearch();
    // else {
    //   var qo = {};
    //   qo[this.valueProp] = this.cvalue;
    //   this.selectedOption = this.findInArray(this.loadedOptions, qo);
    // }
    this.ready = true;
  },
};
</script >

<style >
div.r-select label.q-field--dense button {
  /*width: 10px;*/
  font-size: 17px;
  margin-left: 10px;
}

div.r-select .q-field__prefix {
  font-size: 10px;
  color: #00a9c3;
}

div.r-select label.q-field--dense div.q-field__append {
  width: 21px;
}

div.r-select .q-field--dense .q-field__after, .q-field--dense .q-field__append {
  padding-left: 0px;
}

div.r-select .q-field--auto-height.q-field--dense .q-field__control, .q-field--auto-height.q-field--dense .q-field__native {
  min-height: 25px;
}

div.q-field__suffix.no-pointer-events.row.items-center {
  line-height: normal;
  font-size: 9px;
  padding: 1px;
  margin: 0px;
  border-radius: 3px;
  height: 13px;
  background-color: #012126;
  color: wheat;
}

.option-prefix {
  background-color: #022c33;
  border-radius: 3px;
  color: #ffe6c3;
  font-size: 10px;
  padding: 1px;

  margin: 0px;
  font-size: 9px;
}

span.select-prefix {
  background-color: #6daab5;
  border-radius: 3px;
  color: wheat;
  font-size: 10px;
  padding: 1px;

  margin: 0px;
  font-size: 9px;
}

div.q-field__inner {
  border: 1px solid rgb(122, 146, 136);
  border-radius: 3px;
}

.largefit .el-input__inner {
  height: auto !important;
  line-height: 42px !important;
}

.largefit .el-input--suffix .el-input__inner {
  padding-right: auto !important;
}

.el-select.prefixed span.el-input__prefix {
  right: 0px;
}
</style >
